/** First assigned plan in weekday order — used to auto-focus the editor. */
export function pickFirstPlanSelection(weekdayDetails) {
  if (!weekdayDetails) return null;
  for (const [key, day] of Object.entries(weekdayDetails)) {
    const plan = day.plans?.[0];
    if (plan) {
      return {
        ...plan,
        weekday_id: day.weekday_id ?? key,
        weekday_name: day.name,
      };
    }
  }
  return null;
}

export function planStillInWeekdayDetails(weekdayDetails, targetPlanId) {
  if (!targetPlanId || !weekdayDetails) return false;
  return Object.values(weekdayDetails).some((day) =>
    (day.plans || []).some((p) => p.target_plan_id === targetPlanId)
  );
}

export function resolveWeekdayPlan(weekdayDetails, weekdayId, plan) {
  if (!weekdayId || !plan?.target_plan_id || !weekdayDetails) return plan;
  const day =
    weekdayDetails[weekdayId] ||
    Object.values(weekdayDetails).find(
      (d) => String(d.weekday_id) === String(weekdayId)
    );
  const match = day?.plans?.find((p) => p.target_plan_id === plan.target_plan_id);
  if (!match) return plan;
  return {
    ...match,
    weekday_id: day.weekday_id ?? weekdayId,
    weekday_name: day.name ?? plan.weekday_name,
  };
}

export function getScheduleSummary(weekdayDetails) {
  const days = Object.values(weekdayDetails || {});
  const totalDays = days.length;
  const assignedDays = days.filter((d) => (d.plans || []).length > 0).length;
  return { totalDays, assignedDays };
}

export function formatScheduleDate(value) {
  if (!value) return '—';
  const str = String(value);
  const dateStr = str.includes('T') ? str.split('T')[0] : str;
  const [y, m, d] = dateStr.split('-').map(Number);
  if (!y || !m || !d) return dateStr;
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
